// extracted by mini-css-extract-plugin
export var minHeight = "products-module--minHeight--yizWc";